import React, { Fragment } from "react";

import { Box, Card, CardContent } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

import { times } from "lodash";

const PostListSkeleton = () => (
  <Fragment>
    {times(4).map(idx => (
      <Box key={idx} marginBottom={4}>
        <Card>
          <CardContent>
            <Box display="flex">
              <Skeleton variant="circle" width={40} height={40} />
              <Box marginLeft={2}>
                <Skeleton variant="text" width={100} />
                <Skeleton variant="text" width={50} />
              </Box>
            </Box>
            <Box marginTop={2}>
              {times(4).map(idx => (
                <Skeleton key={idx} variant="text" width="100%" />
              ))}
            </Box>
          </CardContent>
        </Card>
      </Box>
    ))}
  </Fragment>
);

export default PostListSkeleton;
